import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "section-title" }
const _hoisted_2 = { style: {"position":"relative"} }
const _hoisted_3 = { class: "community-carousel" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "links" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "tags" }
const _hoisted_15 = { class: "carousel-controls" }
const _hoisted_16 = { class: "bubbles" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "circle" }
const _hoisted_19 = {
  key: 0,
  class: "circle fill"
}

import { onMounted, watch } from "vue";
import { Alert } from "../alerts";
import { ref, useTemplateRef } from "vue";
import { fitFontSize } from "../helper";

const timer = 1000 * 15;

export default /*@__PURE__*/_defineComponent({
  __name: 'Communities',
  setup(__props) {

_useCssVars(_ctx => ({
  "e832015a": (communities.value.length),
  "v5456d101": (selected.value),
  "v5b0f9ac2": (timer)
}))

function shuffleArray<T>(array: Array<T>, start = 0, end = array.length) {
	for (let i = end - 1; i > start; i--) {
		const j = start + Math.floor(Math.random() * (i - start + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
}

const communitiesEl = useTemplateRef("communitiesEl");

function fitDescriptionTexts() {
	communitiesEl.value?.querySelectorAll(".community").forEach((c: Element) => {
		fitFontSize(c.querySelector(".description")!);
	});
}

onMounted(() => {
	if ("requestIdleCallback" in window) {
		// Fit the first description immediately
		fitFontSize(communitiesEl.value!.querySelector(".community .description")!);
		// And the others on idle
		requestIdleCallback(fitDescriptionTexts);
	} else fitDescriptionTexts();
});

const communities = ref([
	{
		name: "MTG Cube Talk",
		brief: "A friendly server to discuss Cube design, organize online limited events, and talk with over 2,500 other Cube and Magic enthusiasts about the best game in the world!",
		icon: "mtg_cube_talk.webp",
		tags: ["Cube", "Cockatrice", "Design", "Discussion"],
		links: { discord: "https://discord.gg/mtg-cube-talk-263828508126609420" },
		discord_member_count: undefined,
	},
	{
		name: "Arena Pod Draft",
		brief: "Community for frequent and new limited players. Great place to ask for assistance and start a new pod with active members.",
		icon: "arena_pod_draft.webp",
		tags: ["Pod Draft", "Cube", "Chaos", "MTGA", "Duelist", "EU", "NA"],
		links: { discord: "https://discord.gg/wg8dcfD4j3" },
	},
	{
		name: "Arena Gauntlet League",
		brief: "We are a Limited Magic Community on Discord that runs a unique 6-week sealed-deck-type tournament called Gauntlet, with games played out on Arena for fun and prizes.",
		description:
			"We are a Limited Magic Community on Discord running regular tournaments played out on Arena. Each tournament uses the Gauntlet format (of our own creation) as a base: a six-week tournament where you make a 60-card sealed deck from 6 packs, play 5 matches a week against different players, and add a “punishment pack” to your pool after each loss. The Top 8 then compete in a 3-round 6-pack Megadraft for the coveted title of League Champion. We also run weekly Side-Quests which are one-time events usually run via Draftmancer trying out all kinds of different draft types.",
		icon: "gauntlet_league_logo.webp",
		tags: ["Sealed", "Draft", "Tournament", "Event", "MTGA"],
		links: { discord: "https://discord.gg/7TuJqSAhX9", website: "https://f2fleague.wordpress.com/" },
	},
	{
		name: "XMage Draft Historical Society",
		brief: "Come experience the history of Limited Magic with the XDHS!<br />We host six drafts each week, open to all, with a chronological progression plus a variety of bonus formats. Matches are played out as a 3-round Swiss tourney on XMage with a full rules engine, all for free!",
		description:
			"Come experience the history of Limited Magic with the XDHS!<br />We host six drafts each week, open to all, with a chronological progression plus a variety of bonus formats. Matches are played out as a 3-round Swiss tourney on XMage with a full rules engine, all for free!",
		icon: "xdhs.webp",
		tags: ["XMage", "Chrono", "Historical", "Swiss"],
		links: { discord: "https://discord.gg/7xWaCvWyq8" },
	},
	{
		name: "Custom Magic",
		brief: "A Custom Magic community primarily focused on custom set design and development.",
		icon: "custom_magic.webp",
		tags: ["Custom ", "Cockatrice"],
		links: { discord: "https://discord.gg/custommagic" },
	},
	{
		name: "Jank Diver Gaming",
		brief: "A community dedicated to the Cube format, specifically for Magic: Arena play.",
		icon: "jank_diver_gaming.webp",
		tags: ["Cube", "MTGA", "Social"],
		links: {
			youtube: "https://www.youtube.com/@JankDiverGaming",
			discord: "https://discord.gg/G7ucDuK3v9",
			twitter: "https://twitter.com/JankDiverGaming",
		},
	},
	{
		name: "Limited Perspective",
		brief: "Join for Limited Magic using Draftmancer and Tabletop Simulator, stay for the friendly banter and unforgettable moments. Hosting drafts every Saturday night at 6:30 EST.",
		icon: "limited_perspective.webp",
		tags: ["Draft", "Cube", "Progression Series", "TTS"],
		links: {
			discord: "https://discord.gg/f5UYPauRQz",
		},
	},
	{
		name: "The Cube Draft Gathering Place",
		brief: "Community-focused server running Cubes Monday to Friday on Tabletop Simulator. We are open to cubes of any kind or type.",
		icon: "cube_gathering.webp",
		tags: ["Draft", "Cube", "Social", "TTS"],
		links: {
			discord: "https://discord.gg/wRXzJFeRtz",
		},
	},
	{
		name: "Remastering Magic",
		brief: "We at REMA are taking Limited to the next level, by combining the creativity of cubes with the balancing nature of the rarity system - made possible by Draftmancer! We run multiple remastered set drafts per week and play out the matches on XMage. Come and join, whether you want to take part in the remastering yourself, or just draft some cool sets!",
		icon: "REMA.webp",
		tags: ["Remastered", "Set design", "Cubes with rarity", "XMage"],
		links: {
			discord: "https://discord.gg/PnkqwGu6sf",
		},
	},
	{
		name: "Magic Set Editor Modern",
		brief: "<span><strong>Magic Set Editor Modern</strong> (MSEM) is a non-rotating custom Magic the Gathering format consisting of over 70 player-designed sets launched in 2017. We have monthly competitive Grand Prix tournament events, continuous open Constructed League, and weekly Draft Night events! As of January 2025 we also have twice-weekly free to play Cube League events with fun digital prizes to win!</span>",
		icon: "MSEM.webp",
		tags: ["Constructed", "Limited", "Cube", "Custom", "Cockatrice"],
		links: {
			discord: "https://discord.gg/KUd2PvFn2V",
			website: "https://lackeybot.com/msem/gps",
			cube: "https://timespiraled.github.io/",
		},
	},
	{
		name: "NoPain Discord",
		brief: "Italian (and International) Community driven by the passion for Limited MTG.<br />We organize free-to-play Cube Tournaments on a regular basis, mostly drafting NoPainNoGame_'s Unfair Cube (which is a cube designed to be Vintage-Cube-like, but on MTGA), and we also stream them on Twitch!",
		icon: "no_pain.webp",
		tags: ["Limited", "Cube", "MTGA", "Tournament", "ITA", "ENG"],
		links: {
			discord: "https://discord.gg/dRu4vwNea9",
			twitch: "https://www.twitch.tv/NoPainNoGame_ ",
			cube: "https://www.cubecobra.com/cube/list/UnfairCube",
		},
	},
]);
shuffleArray(communities.value);

const selected = ref(0);

const next = () => {
	selected.value = (selected.value + 1) % communities.value.length;
	resetTimeout();
};
const prev = () => {
	selected.value = (communities.value.length + selected.value - 1) % communities.value.length;
	resetTimeout();
};

let timeout = setTimeout(next, timer);
const timeoutStart = ref(0);

const resetTimeout = () => {
	clearInterval(timeout);
	timeout = setInterval(next, timer);
	timeoutStart.value = Date.now();
};

const select = (idx: number) => {
	selected.value = idx;
	resetTimeout();
};

function checkSelectedDiscordMembers() {
	const c = communities.value[selected.value];
	if (c.links.discord && !c.discord_member_count) {
		fetch(
			`https://discord.com/api/v9/invites/${c.links.discord.substring(
				"https://discord.gg/".length
			)}?with_counts=true`
		)
			.then((r) => r.json())
			.then((r) => {
				if (r && r.approximate_member_count) c.discord_member_count = r.approximate_member_count;
			})
			.catch((r) => console.error("Failed to fetch discord stats", r));
	}
}

checkSelectedDiscordMembers();
watch(selected, checkSelectedDiscordMembers);

const explain = () => {
	Alert.fire({
		icon: "info",
		title: "Featured Communities",
		html: `<p>These communities are focused around diverse aspects of Limited Magic and are known to organize tournaments and events using Draftmancer.</p>
		<p>Do you want your own community to be featured here?<br />
		You can submit it by contacting me (Senryoku) via <a href="mailto:dev@draftmancer.com">email</a> or the <a href="https://discord.gg/XscXXNw">Draftmancer Discord</a></p>`,
	});
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, [
        _cache[0] || (_cache[0] = _createTextVNode(" Featured Communities ", -1 /* CACHED */)),
        _createVNode(_component_font_awesome_icon, {
          class: "clickable",
          onClick: explain,
          icon: ['fas', 'question-circle'],
          size: "sm"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "scroller",
          ref_key: "communitiesEl",
          ref: communitiesEl
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(communities.value, (c) => {
            return (_openBlock(), _createElementBlock("div", {
              key: c.name,
              class: "community",
              style: _normalizeStyle(`--icon: url(${require(`../assets/img/communities/${c.icon}`)})`)
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "icon" }, null, -1 /* CACHED */)),
              _createElementVNode("h2", _hoisted_4, _toDisplayString(c.name), 1 /* TEXT */),
              _createElementVNode("div", {
                class: "description",
                innerHTML: c.brief
              }, null, 8 /* PROPS */, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                (c.links.discord)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: c.links.discord,
                      target: "_blank"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['brands', 'discord'] }),
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "link-label" }, " Discord server ", -1 /* CACHED */)),
                      (c.discord_member_count)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(c.discord_member_count) + " members)", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_7))
                  : _createCommentVNode("v-if", true),
                (c.links.youtube)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: c.links.twitter,
                      target: "_blank"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['brands', 'twitter'] }),
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "link-label" }, " Twitter ", -1 /* CACHED */))
                    ], 8 /* PROPS */, _hoisted_9))
                  : _createCommentVNode("v-if", true),
                (c.links.youtube)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: c.links.youtube,
                      target: "_blank"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['brands', 'youtube'] }),
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "link-label" }, " Youtube ", -1 /* CACHED */))
                    ], 8 /* PROPS */, _hoisted_10))
                  : _createCommentVNode("v-if", true),
                (c.links.twitch)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      href: c.links.twitch,
                      target: "_blank"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['brands', 'twitch'] }),
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "link-label" }, " Twitch ", -1 /* CACHED */))
                    ], 8 /* PROPS */, _hoisted_11))
                  : _createCommentVNode("v-if", true),
                (c.links.website)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 4,
                      href: c.links.website,
                      target: "_blank"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'globe'] }),
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "link-label" }, " Website", -1 /* CACHED */))
                    ], 8 /* PROPS */, _hoisted_12))
                  : _createCommentVNode("v-if", true),
                (c.links.cube)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 5,
                      href: c.links.cube,
                      target: "_blank"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'cube'] }),
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "link-label" }, " Cube", -1 /* CACHED */))
                    ], 8 /* PROPS */, _hoisted_13))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.tags, (t) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: t,
                    class: "tag"
                  }, _toDisplayString(t), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ], 4 /* STYLE */))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          onClick: prev,
          class: "clickable"
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-left" })
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(communities.value, (c, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: c.name,
              class: _normalizeClass(["clickable bubble", { active: selected.value === idx }]),
              onClick: ($event: any) => (select(idx))
            }, [
              _createElementVNode("div", _hoisted_18, [
                (selected.value === idx)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                  : _createCommentVNode("v-if", true)
              ])
            ], 10 /* CLASS, PROPS */, _hoisted_17))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", {
          onClick: next,
          class: "clickable"
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
        ])
      ])
    ])
  ]))
}
}

})